<template>
    <div
        v-if="applicantDirectBillingData.direct_billing_active_status == 'active' || applicantDirectBillingData.direct_billing_active_status == 'paused'">
        <vx-card class="mb-5" :title="'Domiciliación ' + cardTitle">
            <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                    <div class="vx-col w-full mb-base">
                        <h5>Última domiciliación procesada</h5>
                        <vs-table stripe :data="applicantDirectBillingData.last_direct_billing"
                            noDataText="No hay datos disponibles">
                            <template slot="thead">
                                <vs-th>Fecha</vs-th>
                                <vs-th>Monto</vs-th>
                                <vs-th>Estado</vs-th>
                                <vs-th>Banco</vs-th>
                            </template>
                            <template slot-scope="{ data }">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                                    <vs-td>{{ regularDateFormat(tr.created_at) }}</vs-td>
                                    <vs-td>{{ moneyFormat(tr.amount, 2) }}</vs-td>
                                    <vs-td>
                                        {{ statusStr(tr.status) }}
                                        <span v-if="tr.status == 'reply_error'">
                                            <br>({{ tr.status_error }})
                                        </span>
                                    </vs-td>
                                    <vs-td>{{ tr.bank_name }}</vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                    <div class="vx-col w-full mb-base">
                        <h5>Domiciliaciones en proceso</h5>
                        <vs-table stripe :data="applicantDirectBillingData.direct_billing_in_process"
                            noDataText="No hay datos disponibles">
                            <template slot="thead" class="thead-dark">
                                <vs-th>Fecha</vs-th>
                                <vs-th>Monto</vs-th>
                                <vs-th>Banco</vs-th>
                            </template>
                            <template slot-scope="{ data }">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                                    <vs-td>{{ regularDateFormat(tr.created_at) }}</vs-td>
                                    <vs-td>{{ moneyFormat(tr.amount, 2) }}</vs-td>
                                    <vs-td>{{ tr.bank_name }}</vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                    <div class="vx-col w-full mb-base">
                        <template v-if="applicantDirectBillingData.direct_billing_active_status == 'active'">
                            <h5>Pausar domiciliación</h5>
                            <vs-button color="success" @click="changeStatusDirectBilling('paused')">Pausar</vs-button>
                        </template>
                        <template v-else>
                            <h5>Activar domiciliación</h5>
                            <vs-button color="success" @click="changeStatusDirectBilling('active')">Activar</vs-button>
                        </template>

                    </div>
                    <div v-if="!directBillingPaused" class="vx-col w-full mb-base">
                        <h5>Generar domiciliación</h5>
                        <vs-input class="w-full" type="text" v-model.lazy="amount" v-money="money" name="amount"
                            icon-pack="feather" icon="icon-dollar-sign" autocomplete="off" />
                        <vs-button class="mt-5"
                            v-if="!loading && applicantDirectBillingData.direct_billing_in_process.length <= 0"
                            color="success" @click="createDirectBilling">Generar</vs-button>
                        <p v-if="applicantDirectBillingData.direct_billing_in_process.length > 0">El solicitante ya
                            cuenta con una
                            domiciliación en proceso</p>
                    </div>
                </div>

            </div>
        </vx-card>
    </div>
</template>

<script>
import formatHelper from '@mixins/formatHelper';
import dateHelper from "@mixins/dateHelper";
import { VMoney } from 'v-money';
import currencyHelper from "@mixins/currencyHelper";
export default {
    name: "ApplicantDirectBilling",
    mixins: [formatHelper, dateHelper, currencyHelper],
    directives: { money: VMoney },
    props: ['ApplicantId'],
    async mounted() {
        await this.getLatestApplicantDirectBilling();
    },
    data() {
        return {
            applicantDirectBillingData: {
                direct_billing_active_status: null,
                direct_billing_in_process: [],
                last_direct_billing: null,
                total_dues: 0
            },
            maxAmountDirectBilling: 50000,
            amount: 0,
            money: {
                decimal: '.',
                thousands: ',',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
            client_id: '',
            loading: false,
        }
    },
    computed: {
        cardTitle() {
            return this.directBillingPaused ? "(Pausada)" : "";
        },
        directBillingPaused() {
            return (this.applicantDirectBillingData.direct_billing_active_status == 'paused');
        }
    },
    methods: {
        async getLatestApplicantDirectBilling() {
            try {
                const res = await axios.get(`api/cobranza/applicant-direct-billing/${this.ApplicantId}`);
                this.applicantDirectBillingData = res.data;
                if (this.applicantDirectBillingData.total_dues < this.maxAmountDirectBilling) {
                    this.maxAmountDirectBilling = this.applicantDirectBillingData.total_dues;
                }
            }
            catch (e) {
            }
        },
        async createDirectBilling() {
            let directBillingAmount = this.unMoneyFormat(this.amount);
            if (directBillingAmount == 0) {
                this.errorNotif("Aviso", "El monto no es válido", 4000);
                return 0;
            }

            if (directBillingAmount > this.maxAmountDirectBilling) {
                this.errorNotif("Aviso", "El monto de la domiciliacion no puede ser mayor a " + this.moneyFormat(this.maxAmountDirectBilling), 4000);
                return 0;
            }

            this.showLoading(true);
            try {
                const res = await axios.post(`api/cobranza/applicant-direct-billing/create`, {
                    amount: directBillingAmount,
                    client_id: this.ApplicantId
                });
                this.successNotif("Aviso", res.data.message, 4000);
                await this.getLatestApplicantDirectBilling();
            } catch (e) {
                if (e.response != undefined && e.response.data != undefined && e.response.data.message != undefined) {
                    this.errorNotif("Aviso", e.response.data.message, 4000);
                } else {
                    console.log(e);
                    this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
                }
            }
            this.showLoading(false);
        },
        async changeStatusDirectBilling(status) {
            this.showLoading(true);
            try {
                const res = await axios.post(`api/cobranza/applicant-direct-billing/change`, {
                    status: status,
                    client_id: this.ApplicantId
                });
                this.successNotif("Aviso", res.data.message, 4000);
                await this.getLatestApplicantDirectBilling();
            } catch (e) {
                if (e.response != undefined && e.response.data != undefined && e.response.data.message != undefined) {
                    this.errorNotif("Aviso", e.response.data.message, 4000);
                } else {
                    console.log(e);
                    this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
                }
            }
            this.showLoading(false);
        },
        statusStr(status) {
            let statusStr = "";
            switch (status) {
                case "created":
                    statusStr = "Creado";
                    break;
                case "reply_ok":
                    statusStr = "Pago recibido";
                    break;
                case "reply_error":
                    statusStr = "Pago recibido con error";
                    break;
                case "collection_completed":
                    statusStr = "Completado";
                    break;
                case "cancelled":
                    statusStr = "Cancelado";
                    break;
                default:
                    break;
            }
            return statusStr;
        }
    }
}
</script>